import { getProgramPrice } from './_getProgramPrice';

export const calculateRoomPrice = async (rooms, arrivalDate, updatePrice, setExpress, setExpressCount) => {
  for (const room of rooms) {
    const periods = [];
    const adultGuests = room.people.filter(guest => guest.type === 'adult');
    const childGuests = room.people.filter(guest => guest.type === 'child');
    let currentArrivalDate = new Date(arrivalDate);

    let tempGuests = adultGuests.map(guest => ({
      ...guest,
      remainingProgramLength: guest.program_length,
    }));

    while (tempGuests.length > 0) {
      const minProgramLength = Math.min(...tempGuests.map(guest => guest.remainingProgramLength));
      const period = {
        days: minProgramLength,
        guestsCount: tempGuests.length,
        startDate: new Date(currentArrivalDate),
      };

      periods.push(period);

      tempGuests.forEach(guest => {
        guest.remainingProgramLength -= minProgramLength;
      });

      tempGuests = tempGuests.filter(guest => guest.remainingProgramLength > 0);

      currentArrivalDate.setDate(currentArrivalDate.getDate() + minProgramLength);
    }
    for (const ppl of adultGuests) {
      let totalPrice = 0;
      let totalDiscountSum = 0;
      let discountPercent = 0;
      let discountText = '';
      let remainingLength = ppl.program_length;

      for (const period of periods) {
        if (remainingLength <= 0) break;

        const periodDays = Math.min(remainingLength, period.days);
        remainingLength -= periodDays;

        const res = await getProgramPrice(
          ppl.program.id,
          ppl.program_type.id,
          periodDays,
          period.guestsCount,
          room.apartment,
          period.startDate.toISOString().split('T')[0],
          ppl.program_length,
        );
        const discount = Number(res.discount) || 0;
        const discountSum = Number(res.discount_sum) || 0;

        totalPrice += res.sum;
        totalDiscountSum += discountSum > 0 ? discountSum : res.sum;
        if (discount > 0 && discountSum > 0) {
          discountPercent = discount;
          discountText = res.discount_text || discountText;
        }
        setExpress(room.id, ppl.id, res.express);
        setExpressCount(room.id, ppl.id, res.expressCount);
      }

      updatePrice(room.id, ppl.id, {
        program_price: totalPrice,
        program_discount_sum: totalDiscountSum,
        program_discount: discountPercent,
        program_discount_text: discountText,
      });
    }

    for (const child of childGuests) {
      const res = await getProgramPrice(
        child.program.id,
        child.program_type.id,
        child.program_length,
        child.guest_id,
        room.apartment,
        arrivalDate,
        child.program_length,
      );

      const childDiscount = Number(res.discount) || 0;
      const childDiscountSum = Number(res.discount_sum) || 0;

      updatePrice(room.id, child.id, {
        program_price: res.sum,
        program_discount_sum: childDiscountSum > 0 ? childDiscountSum : res.sum,
        program_discount: childDiscount,
        program_discount_text: res.discount_text ?? '',
      });
    }
  }
};